export default {
      id: "i-search-icon-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-search-icon",
      toString: function () {
        return this.url;
      }
    }